module.exports = __webpack_public_path__ + "static/img/li9_3.7efda67a.png";